import Swiper from "swiper/bundle";
// import "swiper/css";
// import "swiper/css/bundle";

export const slider = {
  init() {
    this.modal();
  },

  modal() {
    const modal = document.querySelectorAll(".modal-slide");
    const triggers = document.querySelectorAll(".js-modal-slide");

    modal.forEach((element) => {
      const slider = element.querySelector(".swiper");
      if (!slider) return;

      new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev"),
        },
      });
    });

    /**
     * トリガー要素に対してモーダル表示と動画再生のイベントを設定
     *
     * - モーダルのコンテンツIDを取得し、対応するターゲット要素を特定
     * - トリガーがクリックされた際に、アクティブなスライド内の動画を再生
     * - 閉じるボタンや背景がクリックされた際に、すべての動画を一時停止
     */
    triggers.forEach((trigger) => {
      const contentsId = trigger.getAttribute("modal-content");
      console.log("🚀 ~ triggers.forEach ~ contentsId:", contentsId);
      const target = document.getElementById(contentsId);
      console.log("🚀 ~ triggers.forEach ~ target:", target);
      const closeBtn = target.querySelector(".modal-close");
      const modalBg = target.querySelector(".modal-bg");
      const modalSwiper = target.querySelector(".swiper").swiper;

      trigger.addEventListener("click", (event) => {
        const targetSlide = trigger.getAttribute("modal-slide");
        modalSwiper.slideTo(targetSlide, 0);
      });
    });
  },
};
